$(document).ready(function() {

  $('body').on("click", ".serail_submit", function(e) {
    e.preventDefault();
    e.stopPropagation();
    var _this = $(this);
    var order_id = $(this).closest('form').attr("data-order_id");
    var value = "", call_function = true;
    var all_serail_input = $(this).closest('form').find('input.serail_input');
    $('.error').remove();
    all_serail_input.each(function(index, val) {
      value += $(val).attr("data-item_title") + ' : ' + $(val).val() + '\n';
      if (!val.checkValidity()) {
        $(val).closest('.item_serail_wrp').append("<p class='error'>Input must be alphanumeric and up to 15 characters long.</p>");
        call_function =  false;
      }
    });
    if(call_function){
      console.log(value);
      console.log($(this).closest('form').attr("data-order_id"));
  
      var success_msg = $('.serail_submit').attr("data-success") || "Serial number submitted succesfully. Your warranty is now active.";
      
      _this.text("Processing...");
      $('.serail_submit').attr("disabled","disabled");
      $('.all_orders_in_pages').find('.message_after_call').remove();
  
      var data_form = $(this).closest('form').serializeArray();
      data_form.push({
        "name": "Order ID",
        "value": order_id
      });
      data_form.push({
        "name": "Item Serail No.",
        "value": value
      });
      
      $.post($('.all_orders_in_pages').attr('data-action_url'),data_form,function(data, status){
      if(status == 'success'){
        _this.parent().append('<p class="message_after_call">'+success_msg+'</p>');
        _this.text("Submit");
        $('.serail_submit').removeAttr("disabled","disabled");
        setTimeout(function(){
          $('.all_orders_in_pages').find('.message_after_call').remove();
        },4000);
      }else{
        _this.parent().append('<p class="message_after_call">Error updating...Contact Us!</p>');
        _this.text("Submit");
        $('.serail_submit').removeAttr("disabled","disabled");
        setTimeout(function(){
          $('.all_orders_in_pages').find('.message_after_call').remove();
        },4000);
      }
      });
    }
  });

});
